<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <vc-layout :spacing="8">
      <vc-col :span="12" sm24>
        <example-title src="example-1.html" title="All fields, single selection" />
        <vc-select
          color="red"
          label="Select with all fields"
          @input="input"
          name="select-1"
          v-model="model1"
          :items="select1">
        </vc-select>
      </vc-col>
      <vc-col :span="12" sm24>
        <example-title src="example-2.html" title="Searchable, single selection and icon" />
        <vc-select
          searchable
          color="primary"
          label="Searchable select"
          icon="mdi-guitar-electric"
          @input="input"
          name="select-2"
          v-model="model2"
          :items="select2">
        </vc-select>
      </vc-col>
    </vc-layout>
    <vc-layout :spacing="8">
      <vc-col :span="12" sm24>
        <example-title src="example-3.html" title="Multiple selection, search and preselected value" />
        <vc-select
          color="orange"
          label="Multiple selection and search"
          icon="mdi-guitar-electric"
          name="select-3"
          searchable
          @input="input"
          v-model="model3"
          :items="select2"
          multiple>
        </vc-select>
      </vc-col>
      <vc-col :span="12" sm24>
        <example-title src="example-4.html" title="Searchanble, multiple selection with tags" />
        <vc-select
          color="green"
          label="Multiple selection with tags"
          icon="mdi-guitar-electric"
          name="select-4"
          @input="input"
          searchable
          tags
          v-model="model4"
          :items="select2"
          multiple
        ></vc-select>
      </vc-col>
    </vc-layout>
    <vc-layout :spacing="8">
      <vc-col :span="12" sm24>
        <example-title src="example-5.html" title="Disabled select" />
        <vc-select
          color="green"
          disabled
          label="A disabled select"
          name="select-5"
          @input="input"
          tags
          v-model="model5"
          :items="select2"
          multiple>
        </vc-select>
      </vc-col>
      <vc-col :span="12" sm24>
        <example-title src="example-6.html" title="Some items disabled in the select dropdown" />
        <vc-select
          color="deep-purple"
          label="Select with some disabled items"
          name="select-6"
          @input="input"
          v-model="model6"
          :items="select3">
        </vc-select>
      </vc-col>
    </vc-layout>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'SelectPage',
  data () {
    return {
      title: null,
      description: null,
      model1: [],
      model5: [],
      model2: [],
      model3: [{
        label: 'B.C. Rich',
        value: 'bcrich'
      }, {
        label: 'Jackson',
        value: 'jackson'
      }, {
        label: 'ESP',
        value: 'esp'
      }],
      model4: [{
        label: 'B.C. Rich',
        value: 'bcrich'
      }, {
        label: 'Jackson',
        value: 'jackson'
      }, {
        label: 'ESP',
        value: 'esp'
      }],
      model6: [],
      select1: [{
        label: 'Martin',
        value: 'martin ivanov',
        avatar: '/static/images/avatar-01.png',
        secondaryText: 'Cat Owner',
        icon: 'account_circle'
      }, {
        label: 'Whisper',
        value: 'whisper',
        avatar: '/static/images/avatar-02.png',
        secondaryText: 'Cat',
        icon: 'home'
      }, {
        label: 'Shushi',
        value: 'shushi',
        avatar: '/static/images/avatar-02.png',
        secondaryText: 'Cat',
        icon: 'home'
      }, {
        label: 'Alex',
        value: 'alexandra dilcheva',
        avatar: '/static/images/avatar-03.png',
        secondaryText: 'Cat Owner',
        icon: 'home'
      }, {
        label: 'Gabriela',
        value: 'gabriela kehayova',
        avatar: '/static/images/avatar-04.png',
        secondaryText: 'Admin',
        icon: 'home'
      }],
      select2: [{
        label: 'B.C. Rich',
        value: 'bcrich'
      }, {
        label: 'Jackson',
        value: 'jackson'
      }, {
        label: 'ESP',
        value: 'esp'
      }, {
        label: 'Strandberg',
        value: 'strandberg'
      }, {
        label: 'Gibson',
        value: 'gibson'
      }, {
        label: 'Ibanez',
        value: 'ibanez'
      }, {
        label: 'Aurellia',
        value: 'aurellia'
      }, {
        label: 'Fender',
        value: 'fender'
      }, {
        label: 'Etherial',
        value: 'etherial'
      }, {
        label: 'Schecter',
        value: 'schecter'
      }, {
        label: 'Gretsch',
        value: 'gretsch'
      }, {
        label: 'Alvarez',
        value: 'alvarez'
      }, {
        label: 'Blueridge',
        value: 'Blueridge'
      }, {
        label: 'Breedlove',
        value: 'breedlove'
      }, {
        label: 'Carvin / Kiesel',
        value: 'carvin-kiesel'
      }, {
        label: 'Charvel',
        value: 'charvel'
      }, {
        label: 'Cordoba',
        value: 'cordoba'
      }, {
        label: 'Daisy Rock',
        value: 'daisy-rock'
      }, {
        label: 'Dean',
        value: 'dean'
      }, {
        label: 'Epiphone',
        value: 'epiphone'
      }, {
        label: 'Music Man',
        value: 'music-man'
      }, {
        label: 'EVH',
        value: 'evh'
      }, {
        label: 'Godin',
        value: 'godin'
      }, {
        label: 'Kramer',
        value: 'kramer'
      }, {
        label: 'Martin',
        value: 'martin'
      }, {
        label: 'Ovation',
        value: 'ovation'
      }, {
        label: 'PRS',
        value: 'prs'
      }, {
        label: 'Sterling by Music Man',
        value: 'sterling-by-music-man'
      }],
      select3: [{
        label: 'B.C. Rich',
        value: 'bcrich'
      }, {
        label: 'Jackson',
        value: 'jackson',
        disabled: true
      }, {
        label: 'ESP',
        value: 'esp',
        disabled: true
      }, {
        label: 'Strandberg',
        value: 'strandberg'
      }, {
        label: 'Gibson',
        value: 'gibson',
        disabled: true
      }, {
        label: 'Ibanez',
        value: 'ibanez'
      }, {
        label: 'Aurellia',
        value: 'aurellia'
      }]
    }
  },
  mixins: [
    methods
  ],
  mounted () {
    this.getPage()
  },
  methods: {
    input ($event) {
      console.log($event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/select.vue